<template>
  <div>
    <b-card title="" class="mb-0">
      <b-form @submit.prevent>
        <b-row>
          <b-col cols="12" md="2">
             <b-form-group
                label="CN Number"
                label-for="cnNo"
             >
                <b-form-input
                      id="cnNo"
                      size="sm"
                      v-model="form.cn_no"
                      placeholder="CN Number" 
             />
             </b-form-group>
          </b-col>
          <b-col cols="12" md="2">
             <b-form-group
                label="Show All Process"
                label-for="allProcess"
             >
                <b-form-checkbox
                      id="allProcess"
                      v-model="form.all_process"
                      switch
             />
             </b-form-group>
          </b-col>
            <b-col cols="12" md="2">
                <b-button block variant="primary" @click="getData" class="mt-2 pd-1">
                  {{ $t('globalActions.find') }}
                </b-button>
            </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card no-body id="pdfDom">

  <!-- loading -->
    <div class="text-center text-primary my-2 d-flex flex-column justify-content-center"
        v-if="isLoading">
          <div class="text mb-1">
            <b-spinner class="align-middle" />
          </div>
          <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
    </div>

      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th>Process</th>
              <th>Date</th>
              <th>Location</th>
              <th>Amount</th>
              <th style="width: 250px;">Description</th>
              <th>CH AR</th>
              <th>CH AP</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(group, groupIndex) in groupedItems">
              <!-- Group Header -->
              <tr :key="'group-'+groupIndex" class="table-light header-category-account">
                <td class="fw-bold">
                  AWB : {{ group.header.cn_no }}
                </td>
                <td class="fw-bold">
                  Date : {{ formatDatepicker(group.header.cn_date, false) }}
                </td>
                <td class="fw-bold">
                  Origin : {{ group.header.cn_origin }}
                </td>
                <td class="fw-bold">
                  Koli : {{ group.header.cn_koli }}
                </td>
                <td class="fw-bold">
                  Weight : {{ group.header.cn_weight }}
                </td>
                <td class="fw-bold">
                  Total : {{ formatCurrency(group.header.cp_amount_total, false) }}
                </td>
              </tr>
              <!-- Group Items -->
              <tr v-for="(item, index) in group.items" :key="'item-'+group.header.cn_no+'-'+index">
                <td>{{ item.cp_process }}</td>
                <td>{{ formatDatepicker(item.cp_date, false) }}</td>
                <td>{{ item.cp_origin }} - {{ item.cp_destination }}</td>
                <td class="text-right">{{ formatCurrency(item.cp_amount, false) }}</td>
                <td>{{ item.cp_description }} ({{ item.cp_vehicle }})</td>
                <td>{{ item.ch_ar }}</td>
                <td>{{ item.ch_ap }}</td>
              </tr>
            </template>
            <!-- Empty state -->
            <tr v-if="!itemLists.length && !isBusy">
              <td colspan="10" class="text-center">No matching records found</td>
            </tr>
            <!-- Loading state -->
            <tr v-if="isBusy">
              <td colspan="10" class="text-center">
                <b-spinner class="align-middle"></b-spinner>
                <strong>{{ $t('globalActions.fetchingDataAPI') }}</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BFormCheckbox
} from 'bootstrap-vue'

import { ref, onMounted, computed } from '@vue/composition-api'
import useListTable from '@/comp-functions/useListTable'
import {formatCurrency, formatDatepicker} from '@/utils/formatter'
import useFormResource from '@/comp-functions/useFormResource'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BFormCheckbox
  },
  setup () {

    const { 
      paramsId
    } = useFormResource({ url: 'transaction/journal', localeContextPath: 'apps.transactionsJournal.singular.transaction', redirectPathName: 'apps-report-journal' })


    const isLoading = ref(false)
     const {
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists
    } = useListTable({ url: false })

    // Group items by cn_no
    const groupedItems = computed(() => {
      const result = []
      
      if (itemLists.value && itemLists.value.length) {
        const groups = {}
        
        // Group items by cn_no
        itemLists.value.forEach(item => {
          const cn_no = item.cn_no
          
          if (!groups[cn_no]) {
            groups[cn_no] = {
              items: [],
              header: {
                cn_no: item.cn_no,
                cn_date: item.cn_date,
                cn_origin: item.cn_origin,
                cn_koli: item.cn_koli,
                cn_weight: item.cn_weight,
                cp_amount_total: item.cp_amount_total
              }
            }
          }
          
          groups[cn_no].items.push(item)
        })
        
        // Convert to array format for v-for
        for (const cn_no in groups) {
          result.push({
            header: groups[cn_no].header,
            items: groups[cn_no].items
          })
        }
      }
      
      return result
    })

    onMounted(() => {
      if (paramsId) {
        form.value.cn_no = paramsId
        getData()
      }
    })


    // Table Handlers
    const columnToBeFilter = ['code']

    const form = ref({
      cn_no: '',
      all_process: false
    })

    const getData = async () => {
      if (!form.value.cn_no) {
        return
      }
      
      const params = [
        `cn_no=${form.value.cn_no}`,
        `all_process=${form.value.all_process}`
      ]
      isLoading.value = true

      const url = `reports/tracking?${ params.join('&') }`
      await fetchLists(url)
      isLoading.value = false
    }
    
    return {
      paramsId,
      isLoading,
      form,
      getData,
      isBusy,
      itemLists,
      perPage,
      currentPage,
      totalList,
      dataMeta,
      sortBy,
      perPageOptions,
      searchQuery,
      isSortDirDesc,
      refListTable,
      statusFilter,
      fetchLists,
      columnToBeFilter,
      formatCurrency,
      formatDatepicker,
      groupedItems
    }
  }
}
</script>

<style lang="scss">
.header-category-account {
  font-weight: 600;
  font-size: 1rem;
  font-style: italic;
}

table th, table td {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
